import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SeoHead({
  title,
  description,
  isHome = false,
  ogImage = 'https://assets.auxodev.dk/assets/d61c94bc-c5ec-439d-a220-afcc00eef7a0/hero-service-professional.png'
}) {
  const siteName = 'Myserviceforyou';
  const fullTitle = isHome ? `${siteName} | SoMe Sparring, Redigering & Synlighed` : (title ? `${title} - ${siteName}` : siteName);
  const defaultDesc = 'Myserviceforyou tilbyder sparring, videoredigering, styring af Meta-postkalender og profilopsætning med fokus på reel synlighed. 0 binding.';
  const metaDesc = description || defaultDesc;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
